import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import {
  AppBar,
  Box,
  Button,
  Container,
  Divider,
  Toolbar,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import { LogoFnl2cHorzC, LogoMark2cIconC } from '@/assets';
import { useAuth } from '@/auth';
import { globalTypes } from '@/shared/duck';
import { muiPalette } from '@/shared/general-theme';
import { useMedia } from '@/shared/hooks';

import { WelcomeMobileHeader } from './components';

const WelcomeHeader: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { login } = useAuth();
  const { isSmallScreen } = useMedia();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems: globalTypes.MenuItemList[] = [
    // eslint-disable-next-line no-console
    { title: 'Solutions (ToDo)', itemAction: () => console.log('Solutions clicked') },
    // eslint-disable-next-line no-console
    { title: 'Pricing (ToDo)', itemAction: () => console.log('Pricing clicked') },
  ];

  return (
    <AppBar
      position='fixed'
      sx={{
        backgroundColor: scrolled ? '#0B1524D9' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.2)' : 'none',
        transition: 'all 0.3s ease-in-out',
        borderBottom: scrolled ? `1px solid ${muiPalette.border.dark}` : '1px solid #0B1524D9',
      }}
    >
      <Container maxWidth='lg'>
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            py: scrolled ? 1 : 2,
            transition: 'padding 0.3s',
            paddingLeft: 'initial !important',
            paddingRight: 'initial !important',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              component='div'
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontWeight: 800,
                fontSize: '1.5rem',
                letterSpacing: '-0.02em',
                color: muiPalette.primary.main,
              }}
            >
              {isSmallScreen ? (
                <LogoMark2cIconC
                  style={{
                    height: '2rem',
                  }}
                />
              ) : (
                <LogoFnl2cHorzC
                  style={{
                    height: '2rem',
                    cursor: 'default',
                  }}
                />
              )}

              <Divider
                orientation='vertical' flexItem sx={{
                mx: 2,
                height: '1.5rem',
                alignSelf: 'center',
                borderColor: muiPalette.grey[600],
              }}
              />

              <Typography
                variant={isSmallScreen ? 'body1' : 'h6'}
                component='div'
                sx={{
                  fontWeight: 800,
                  letterSpacing: '-0.02em',
                  color: muiPalette.primary.main,
                }}
              >
                PLATYPUS<span style={{ color: muiPalette.tertiary.main }}>.</span>
              </Typography>

            </Box>
          </Box>

          {isSmallScreen ? (
            <>
              <WelcomeMobileHeader login={login} menuItems={menuItems} />
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              {menuItems.map((item) => (
                <Button
                  key={item.title}
                  variant='text'
                  onClick={item.itemAction}
                  sx={{
                    color: muiPalette.grey[50],
                    '&:hover': {
                      backgroundColor: muiPalette.grey[900],
                    },
                  }}
                >
                  {item.title}
                </Button>
              ))}

              <Button
                variant='contained'
                color='primary'
                startIcon={<AccountCircleOutlinedIcon />}
                sx={{
                  borderRadius: '100px',
                  px: 3,
                  boxShadow: `0 4px 14px ${muiPalette.primary.main}40`,
                }}
                onClick={login}
              >
                Login
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default WelcomeHeader;
